export function getElementBox(elem) {
  let el = elem;
  let offsetTop = 0;
  let offsetLeft = 0;
  const offsetHeight = el.offsetHeight;
  const offsetWidth = el.offsetWidth;

  do {
    if (el.style.position === 'fixed') {
      offsetTop += window.pageYOffset - Math.abs(el.offsetTop);
      break;
    } else if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop;
    }
    if (!isNaN(el.offsetLeft)) {
      offsetLeft += el.offsetLeft;
    }
  } while ((el = el.offsetParent) !== null);

  return {
    top: offsetTop,
    left: offsetLeft,
    height: offsetHeight,
    width: offsetWidth
  };
}



// WEBPACK FOOTER //
// ../core/src/utils/animations.js